import groq from 'groq';

import { ASSET } from '../common';

export const SPEAKERS = groq`
  speakers[]->{
    name,
    biography,
    role,
    image { ${ASSET} },
  }
`;
